/** Delivery channels an office can toggle per notification type. */
export const NOTIFICATION_CHANNELS = ['email', 'push', 'text'] as const;

export type TNotificationChannel = (typeof NOTIFICATION_CHANNELS)[number];

/**
 * One row of the office notification settings as returned by the API.
 *
 * The API sends all three channel booleans regardless of whether the
 * notification actually supports that channel, so a `true` here does NOT mean
 * the office opted in — only `notificationTypeMap` knows which channels are
 * genuinely offered. Never infer availability from these keys.
 */
export interface INotificationSettingRecord {
  event: string;
  email?: boolean;
  push?: boolean;
  text?: boolean;
}

/** The `isEmail` / `isPush` / `isText` availability flags from `notificationTypeMap`. */
export interface INotificationChannelAvailability {
  isEmail?: boolean;
  isPush?: boolean;
  isText?: boolean;
}

/** Channels genuinely offered per notification type, keyed by server event name. */
export type TOfferedChannelsByEvent = Record<string, TNotificationChannel[]>;

/**
 * How an office has configured each notification type, as flat PostHog values —
 * `{ notif_pref_offer_received: 'email,push' }`. Flat strings stay filterable in
 * cohorts; PostHog cannot filter on nested objects.
 */
export type TNotificationPreferenceProperties = Record<string, string>;
